<template>
    <div>
        <div class="columns">
            <div class="column">
                <div class="field has-addons">
                    <p class="control">
                        <a
                            class="button"
                            :class="{'is-active': filter === 'all'}"
                            @click="filter = 'all'"
                        >All</a>
                    </p>
                    <p class="control">
                        <a
                            class="button"
                            :class="{'is-active': filter === 'popular'}"
                            @click="filter = 'popular'"
                        >
                            <span class="icon is-small">
                                <i class="fas fa-star has-text-warning"></i>
                            </span>
                            <span>Popular</span>
                        </a>
                    </p>
                    <p class="control">
                        <a
                            class="button"
                            :class="{'is-active': filter === 'new'}"
                            @click="filter = 'new'"
                        >
                            <span class="icon is-small">
                                <i class="fas fa-fire has-text-danger"></i>
                            </span>
                            <span>New</span>
                        </a>
                    </p>
                </div>
            </div>
            <div class="column">
                <a class="button is-danger is-outlined is-pulled-right" @click="sync">Sync</a>
            </div>
        </div>

        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Pop.</th>
                    <th>New</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Id</th>
                    <th>Priority</th>
                    <th>Is enabled</th>
                    <th>Is hidden</th>
                    <th>Use cache</th>
                    <th>Tags</th>
                    <th>Sub-category</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <template
                    v-for="(game, index) in uiGames"
                >
                    <tr
                        :key="`${game.gameId}-g`"
                        :class="{ 'is-selected': gameToEdit && gameToEdit.gameId === game.gameId }"
                    >
                        <td>{{index + 1}}</td>
                        <td>
                            <span class="icon is-medium toggle"
                                  :class="{'has-text-warning':game.isPopular, 'has-text-grey-lighter':!game.isPopular}"
                                  @click="game.isPopular = !game.isPopular; save(game);">
                                <i class="fas fa-2x fa-star"></i>
                            </span>
                        </td>
                        <td>
                            <span class="icon is-medium toggle"
                                  :class="{'has-text-danger':game.isNew, 'has-text-grey-lighter':!game.isNew}"
                                  @click="game.isNew = !game.isNew; save(game);">
                                <i class="fas fa-2x fa-fire"></i>
                            </span>
                        </td>
                        <td>{{game.category}}</td>
                        <td>
                            <p v-if="game.name"><span v-if="game.displayName">Tech. name:</span> <span class="has-text-weight-bold">{{game.name}}</span></p>
                            <p v-if="game.displayName">Disp. name: {{game.displayName}}</p>
                            <p v-if="!game.name && !game.displayName">[no name]</p>
                        </td>
                        <td>
                            <img :src="game.thumbnailUrl" class="thumbnail" />
                        </td>
                        <td>
                            <p>{{game.gameId}}</p>
                            <p v-if="game.gameSourceProvider"
                               class="has-text-grey">{{game.gameSourceProvider}}</p>
                        </td>
                        <td>
                            <div class="field has-addons">
                                <div class="control">
                                    <input class="input is-small"
                                           type="number"
                                           placeholder="priority"
                                           v-model="game.priority" />
                                </div>
                                <div class="control">
                                    <a class="button is-info is-small" @click="save(game)">
                                        <span class="icon is-small">
                                            <i class="far fa-save"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="tag button-tag"
                                  :class="{'is-success':game.isEnabled}"
                                  @click="game.isEnabled = true; save(game);">enabled</span>
                            <span class="tag button-tag"
                                  :class="{'is-danger':!game.isEnabled}"
                                  @click="game.isEnabled = false; save(game);">disabled</span>
                        </td>
                        <td>
                            <span class="tag button-tag"
                                  :class="{'is-success':!game.isHidden}"
                                  @click="game.isHidden = false; save(game);">visible</span>
                            <span class="tag button-tag"
                                  :class="{'is-danger':game.isHidden}"
                                  @click="game.isHidden = true; save(game);">hidden</span>
                        </td>
                        <td>
                            <span class="tag button-tag"
                                  :class="{'is-success':game.useCache}"
                                  @click="game.useCache = true; save(game);">enabled</span>
                            <span class="tag button-tag"
                                  :class="{'is-danger':!game.useCache}"
                                  @click="game.useCache = false; save(game);">disabled</span>
                        </td>
                        <td>{{game.tags && game.tags.join(', ')}}</td>
                        <td>{{game.subCategory}}</td>
                        <td><a class="button is-small" @click="setGameToEdit(game)">Edit</a></td>
                    </tr>
                    <tr v-if="gameToEdit && gameToEdit.gameId === game.gameId" :key="`${game.gameId}-e`">
                        <td colspan="14">
                            <article class="message">
                                <div class="message-header">
                                    <p>{{gameToEdit.name}} <span v-if="gameToEdit.displayName"> / {{gameToEdit.displayName}}</span></p>
                                    <button class="delete" aria-label="delete" @click="setGameToEdit(null)"></button>
                                </div>
                                <div class="message-body">
                                    <!-- Id -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">PaH db id</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.id" readonly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- GameId -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Prov. game id</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.gameId" readonly />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Name -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Name</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.name" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- DisplayName -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Display name</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.displayName" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- BackgroundUrl -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Background url</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.backgroundUrl" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- ThumbnailUrl -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Thumbnail url</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.thumbnailUrl" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Category -->
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label class="label">Category</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <input class="input oc-input" type="text" v-model="gameToEdit.category" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field is-horizontal">
                                        <div class="field-label">
                                            <!-- Left empty for spacing -->
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="control">
                                                    <button class="button is-primary" @click="edit(gameToEdit)">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: 'games-list',
    props: {
        provider: {
            type: String,
            required: true
        },
        save: {
            type: Function,
            required: true
        },
        sync: {
            type: Function,
            required: true
        },
        edit: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            filter: 'all',
            games: [],
            gameToEdit: null,
        };
    },
    computed: {
        uiGames() {
            return this.filter === 'all'
                ? this.games
                : this.filter === 'new'
                ? this.games.filter(g => g.isNew)
                : this.games.filter(g => g.isPopular);
        }
    },
    methods: {
        async set(games) {
            this.games = games;
        },
        setGameToEdit(game) {
            this.gameToEdit = game;
        }
    }
};
</script>
<style scoped>
.thumbnail {
    max-width: 50px;
}
.toggle {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/games-list.vue